export const accountingDocConstants = {
  ACCOUNTING_DOC_LIST_LOADING: 'ACCOUNTING_DOC_LIST_LOADING',
  ACCOUNTING_DOC_LIST_SUCCESS: 'ACCOUNTING_DOC_LIST_SUCCESS',
  ACCOUNTING_DOC_LIST_FAILURE: 'ACCOUNTING_DOC_LIST_FAILURE'
};
